import { XMarkIcon } from '@heroicons/react/24/outline'
import { FC, ReactNode, useEffect, useRef } from 'react'

import { cn } from '@/app/utils'

const DEFAULT_TOAST_DURATION = 3000

type Props = {
  opened: boolean
  message: string
  onClose: () => void
  icon?: ReactNode
  duration?: number
  className?: string
}

const AppToast: FC<Props> = ({
  opened,
  message,
  onClose,
  icon,
  duration = DEFAULT_TOAST_DURATION,
  className
}) => {
  const onCloseRef = useRef(onClose)

  useEffect(() => {
    onCloseRef.current = onClose
  }, [onClose])

  useEffect(() => {
    if (!opened) {
      return
    }

    const timer = setTimeout(() => onCloseRef.current(), duration)

    return () => clearTimeout(timer)
  }, [opened, duration])

  if (!opened) {
    return null
  }

  return (
    <div
      className={cn(
        'fixed bottom-24 right-24 z-50 flex gap-8 rounded-12 bg-grey-100 p-12 text-white',
        'sm:bottom-16 sm:left-16 sm:right-16',
        className
      )}
    >
      {icon}

      <span className="mr-auto !leading-[20px] text-16">{message}</span>

      <button title="Закрыть" onClick={() => onCloseRef.current()}>
        <XMarkIcon className="h-20 w-20 opacity-30" />
      </button>
    </div>
  )
}

export default AppToast
